export default {
	applyButton: "Apply template",
	cancelButton: "Cancel",
	backBreadcrumb: "Templates",
	templateBreadcrumb: "{title}",
};
